/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clear_FormattingInputs */

const en_clear_formatting = /** @type {(inputs: Clear_FormattingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear Formatting`)
};

const fr_clear_formatting = /** @type {(inputs: Clear_FormattingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Effacer la mise en forme`)
};

const de_clear_formatting = /** @type {(inputs: Clear_FormattingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatierung löschen`)
};

const it_clear_formatting = /** @type {(inputs: Clear_FormattingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancella formattazione`)
};

const ru_clear_formatting = /** @type {(inputs: Clear_FormattingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Очистить форматирование`)
};

const es_clear_formatting = /** @type {(inputs: Clear_FormattingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Borrar formato`)
};

const zh_cn2_clear_formatting = /** @type {(inputs: Clear_FormattingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`清晰格式`)
};

const ja_clear_formatting = /** @type {(inputs: Clear_FormattingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`書式をクリア`)
};

const hi_clear_formatting = /** @type {(inputs: Clear_FormattingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्पष्ट स्वरूपण`)
};

const pt_pt2_clear_formatting = /** @type {(inputs: Clear_FormattingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatação clara`)
};

/**
* | output |
* | --- |
* | "Clear Formatting" |
*
* @param {Clear_FormattingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const clear_formatting = /** @type {((inputs?: Clear_FormattingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clear_FormattingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_clear_formatting(inputs)
	if (locale === "de") return de_clear_formatting(inputs)
	if (locale === "it") return it_clear_formatting(inputs)
	if (locale === "ru") return ru_clear_formatting(inputs)
	if (locale === "es") return es_clear_formatting(inputs)
	if (locale === "zh-CN") return zh_cn2_clear_formatting(inputs)
	if (locale === "ja") return ja_clear_formatting(inputs)
	if (locale === "hi") return hi_clear_formatting(inputs)
	if (locale === "pt-PT") return pt_pt2_clear_formatting(inputs)
	return en_clear_formatting(inputs)
});